import { render, staticRenderFns } from "./downSalaryAwardRuleList.vue?vue&type=template&id=15938ac2&scoped=true&"
import script from "./downSalaryAwardRuleList.vue?vue&type=script&lang=js&"
export * from "./downSalaryAwardRuleList.vue?vue&type=script&lang=js&"
import style0 from "./downSalaryAwardRuleList.vue?vue&type=style&index=0&id=15938ac2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15938ac2",
  null
  
)

export default component.exports